module.exports = __webpack_public_path__ + "img/female-elderly-figure.266843de.svg";